import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { PageHeader, Tag, Button, Tooltip, DatePicker,Select } from 'antd';
import { AuditOutlined } from '@ant-design/icons';

import { pageHeaderStyle, pageTitle } from '../util/Style';

import { AgGridReact } from 'ag-grid-react';

import DenominationStore from './DenominationStore';

import DenominationDrawer from './DenominationDrawer';
import moment from 'moment';

const { RangePicker } = DatePicker;
const height = window.innerHeight * .80;

const currentDate = new Date();
 const startDate =moment(currentDate);
  const endDate = moment(currentDate);
  const defaultDateRange = [startDate, endDate];


const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    flex: 1,
    width: 100,
};

const dateFormat = 'DD-MM-YYYY';

const columnDefs = [
    { headerName: 'Id', field: 'id', pinned: 'left', type: 'numberColumn' },
    {
        headerName: 'Status',
        field: 'status',
        width: 10,
        pinned: 'left',
        type: 'numberColumn',
        cellStyle: params => {
            if (params.value === 1) {
                return { color: 'white', backgroundColor: 'rgb(27,160,97)' };
            }
            return { color: 'white', backgroundColor: 'rgb(204,47,16)' };
        }
    },
    { headerName: 'Branch', field: 'BranchName', filter: 'agTextColumnFilter' },
    { headerName: 'Collected By', field: 'collectedBy', filter: 'agTextColumnFilter' },
    { headerName: 'Collected Date', field: 'PaymentCollectedDate', type: 'dateColumn'},
    { headerName: 'Total Amount', field: 'TotalAmount', headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Payment Type', field: 'PaymentType', filter: 'agTextColumnFilter' },
    { headerName: 'Deposit To', field: 'PaymentType', filter: 'agTextColumnFilter' },
    { headerName: 'Description', field: 'Description', filter: 'agTextColumnFilter' },
    { headerName: 'Received By', field: 'receivedBy', filter: 'agTextColumnFilter', },
    {
        headerName: 'Received Date', field: 'date', type: 'dateColumn',
        cellRenderer: (data) => {
            return moment(data.value).format('DD/MM/YYYY HH:mm')
        }
    },
    { headerName: 'Total Amount', field: 'TotalAmount', headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Payment Type', field: 'PaymentType', filter: 'agTextColumnFilter' },
    { headerName: 'Description', field: 'Description', filter: 'agTextColumnFilter' },
    { headerName: 'Received By', field: 'receivedBy', filter: 'agTextColumnFilter', },
    
];

class DenominationUi extends Component {
    

    gridRef = React.createRef();

    constructor(props) {
        super(props);
        this.store = new DenominationStore({ apiProxy: props.appStore.apiProxy })
        this.state = {
            startDate: moment(currentDate).format("DD/MM/YYYY"),
            endDate: moment(currentDate).format("DD/MM/YYYY")
        };
        this.store.GetallBranchName();
    }

    fetchData = () => {
        this.store.fetchCashDenominations();
    }

    filterBranch = (value) => {
        console.log(value);
        this.store.branchId = value;
        this.store.fetchCashDenominations();
    }

    tag = () => {
        return (
            <div style={{width:"900px"}}>
                {this.countTag()}
                {this.dateFilter()}
                {this.branchFilter()}
            </div>
        )
    }

    countTag = () => {
        if (this.store.isDone) {
            return (
                <>
                    <Tag color="#108ee9">{this.store.rowCount} Total</Tag>
                    <Tag color="geekblue"> {this.store.totalAmountSum} Total </Tag>
                </>
            )
        }

        if (this.store.isError) {
            return <Tag color="red">...</Tag>
        }

    }

    onBtExport = async () => {
        await this.gridRef.current.api.exportDataAsCsv();
    };

    branchFilter = () => {
        if(this.store.isBranchDone) {
            return (
                <Select style={{width: "40%"}} options={this.store.branchList} onChange={(value) => this.filterBranch(value)} placeholder='Branch' />
            )
        }
    }

    exportCsv = () => {
        return(
            <Button onClick={() => this.onBtExport()} shape="round" style={{ background: "rgb(27,160,97)", color: "white" }} >Export CSV</Button>
        )
    }

    approveDenomination = async () => {

        const ids = this.store.denominations.map((denomination) => {
            return denomination.id;
        });

        await this.store.approve(ids);
        this.fetchData();
        this.gridRef.current.api.redrawRows();
    }

    approveButton = () => {
        if (this.props.appStore.isHead) {
            return (
                <Tooltip title="Csah Denomination Approval">
                    <Button onClick={() => this.approveDenomination()} shape="round" style={{ background: "rgb(27,160,97)", color: "white" }} disabled={this.store.isLoading} icon={<AuditOutlined />}>Approve All</Button>
                </Tooltip>
            )
        }
    }

    onChange = (dateString) => {

        let start = dateString[0];
        let end = dateString[1];

        this.store.startDate = start;
        this.store.endDate = end;

        this.fetchData();
    };

    dateFilter = () => {

        return (
            <RangePicker  defaultValue={defaultDateRange}   onChange={this.onChange} format={dateFormat} />
        );

    }


    onSelectionChanged = () => {
        const selectedRows = this.gridRef.current.api.getSelectedRows();

        this.store.denominationNotes = selectedRows[0].notes;
        this.store.totalAmount = selectedRows[0].TotalAmount;
        this.store.totalCharges = selectedRows[0].Totalcharges;
        this.store.paymentType = selectedRows[0].PaymentType;
        this.store.denominationId = selectedRows[0].id;

        this.store.isDrawerOpened = true;
    }

    render() {
        const products = this.store.denominations;
        return (
            <>
                <PageHeader
                    style={pageHeaderStyle}
                    title={pageTitle("Cash Denominations")}
                    tags={[this.tag()]}
                    extra={[
                        this.exportCsv(),
                        this.approveButton()
                    ]}
                >
                </PageHeader>

                <div className="ag-theme-alpine" style={{ height: height, width: '100%' }}>
                    <AgGridReact
                        rowHeight={30}
                        ref={this.gridRef}
                        defaultColDef={defaultColDef}
                        rowData={products}
                        rowSelection={'single'}
                        onSelectionChanged={this.onSelectionChanged}
                        columnDefs={columnDefs}
                        onGridReady={this.fetchData}>
                    </AgGridReact>
                </div>
                <div>
                    <DenominationDrawer store={this.store} appStore={this.props.appStore} gridRef={this.gridRef}></DenominationDrawer>
                </div>
            </>
        )
    }
}

export default observer(DenominationUi)
